/** Cabecera HTTP con etiqueta de dispositivo (Client Hints); el back fusiona con User-Agent nativo. */
export const DEVICE_LABEL_HEADER = 'X-Device-Label';
